module.exports = __webpack_public_path__ + "static/media/marni-back-icon.3c758d83.svg";